export const getUser = state => state.auth.user
export const getUserId = state => state.auth.user && state.auth.user.id
export const getUserLocale = state => state.auth.user && state.auth.user.locale
export const getUserIsAdmin = state =>
  state.auth.user && state.auth.user.role && state.auth.user.role !== 'user'

export const getAccessToken = state =>
  state.auth.token && state.auth.token.access_token

export const getRefreshToken = state => {
  return state.auth.token && state.auth.token.refresh_token
}
